import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, SxProps, Typography } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { useTranslation } from "@/i18n/client";
import { useRouter } from 'next/navigation'

export interface ITextLinkProps {
  name: string;
  href: string;
  canBackWard?: boolean;
}

export interface ITextLinkPropsWrap {
  data: ITextLinkProps[];
  data2: string | undefined;
}

const TextStyle: SxProps = {
  fontWeight: { xs: 400, sm: 400, xl: 400 },
  fontSize: { xs: "12px", sm: "14px", xl: "18px" },
  lineHeight: { xs: "27px", sm: "27px", xl: "27px" },
  color: "#333333",
};
const TextLastStyle: SxProps = {
  fontWeight: { xs: 400, sm: 400, xl: 400 },
  fontSize: { xs: "12px", sm: "14px", xl: "18px" },
  lineHeight: { xs: "27px", sm: "27px", xl: "27px" },
  color: "#A1A1A1",
  width: { xs: "50px", md: "400px", lg: "600px", xl: "600px" },
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const TextLink = ({ data, data2 }: ITextLinkPropsWrap) => {
  const { t } = useTranslation();
  const router = useRouter();

  const handleBackNavigate = () => {
    if (data[1]?.canBackWard){
      return router.back()
    }
    else {
      return router.push(data[1].href)
    }
  }

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      sx={{
        ...TextStyle,
        ":hover": {
          textDecoration: "none",
        },
      }}
    >
      {t(`Article.dataLink.${data[0].name}`)}
    </Link>,

    <Box
      data-testid="Article.dataLink.Article"
      key="Article.dataLink-2"
      color="inherit"
      sx={{
        ...TextStyle,
        ":hover": {
          textDecoration: "underline",
          cursor: "pointer",
        },
      }}
      onClick={() => handleBackNavigate()}
    >
      {t(`Article.dataLink.${data[1].name}`)}
    </Box>,

    <Typography key="3" sx={{ ...TextLastStyle }}>
      {data2}
    </Typography>,
  ];

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
};

export default TextLink;
